import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/design-system/table';
import { useDynamicLocale } from '@/hoslog-intl';
import { formatAmount } from '@/lib/format';
import { cn } from '@/lib/utils';
import { MonthlyReportData } from '@/services/payment/payment.types';
import { MONTHLY_REPORT_LABELS } from '../../constants';

export const ApproveAllConfirmationDialog = ({ selectedData }: { selectedData: MonthlyReportData[] }) => {
  const { t } = useDynamicLocale();
  // Fixed widths keep long labels from widening the dialog's grid past its max width.
  const tableHeaders = [
    { label: t('common.page.tableColumn.sn'), className: 'w-12 text-left' },
    { label: t('common.page.tableColumn.requestId'), className: 'w-[30%] text-left' },
    { label: t('common.page.tableColumn.affiliateInformation'), className: 'text-left' },
    {
      label: t(MONTHLY_REPORT_LABELS.requestedAmount),
      className: 'w-[32%] text-right',
    },
  ];
  const totalAmount = selectedData.reduce((sum, payment) => sum + payment.requestedAmount, 0);

  return (
    // No top margin: the dialog's description footer already pads below the grey bar.
    <div className="min-w-0 mx-4 mb-5 rounded-xs border border-muted">
      <Table className="table-fixed">
        <TableHeader>
          <TableRow className="border-b border-muted">
            {tableHeaders.map((header) => (
              <TableHead
                key={header.label}
                className={cn(
                  'h-auto px-3 py-2.5 text-xs text-secondary whitespace-normal break-words',
                  header.className,
                )}
              >
                {header.label}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {selectedData.map((payment, i) => (
            <TableRow className="border-b border-muted" key={payment.requestId}>
              <TableCell className="px-3 py-2.5 text-xs">{i + 1}</TableCell>
              <TableCell className="px-3 py-2.5 text-xs break-words">{payment.requestId}</TableCell>
              <TableCell className="px-3 py-2.5 text-xs break-words">{payment.accountName}</TableCell>
              <TableCell className="px-3 py-2.5 text-xs text-right whitespace-nowrap">
                {formatAmount(payment.requestedAmount)}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <div className="border-t border-muted px-3 py-2.5 text-right text-caption font-medium">
        {t('common.page.table.total')}: {formatAmount(totalAmount)}
      </div>
    </div>
  );
};
